import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/shared/Icon'
import Tooltip from 'components/shared/Tooltip'
import TooltipText from './TooltipText'

import iconSendActive from 'assets/icons/ico-send-active.svg'
import iconSend from 'assets/icons/ico-send.svg'

import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { getSelectedInteraction, isChatEnabled } from 'state/selectors'
import * as Actions from 'state/actions'


const SendButton = (props) => {
  const { setMessage, message } = props
  const dispatch = useDispatch()
  const { assigned } = useSelector(getSelectedInteraction)
  const send = useSelector(isChatEnabled)

  const handleMessage = () => {
    if(message && send) {
      if(!assigned) dispatch(Actions.assignInteraction())
      dispatch(Actions.sendMessage(message))
      setMessage('')
    }
  }
  return(
    <Tooltip
      trigger={() => (
        <Icon
          onClick = {handleMessage}
          src={
            message
              ? iconSendActive
              : iconSend
          }
        />
      )}
      type='arrow'
      position='top'
    >
      <TooltipText>Send message</TooltipText>
    </Tooltip>
  )
}
SendButton.propTypes = {
  setMessage: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
}

export default SendButton
